import { render } from "./TaxComponent.vue?vue&type=template&id=674f1e32"
import script from "./TaxComponent.vue?vue&type=script&lang=js"
export * from "./TaxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Tax/TaxComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "674f1e32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('674f1e32', __exports__)) {
    api.reload('674f1e32', __exports__)
  }
  
  module.hot.accept("./TaxComponent.vue?vue&type=template&id=674f1e32", () => {
    api.rerender('674f1e32', render)
  })

}


export default __exports__